import React from "react";

export const ActiveTermContext = React.createContext({
    activeTerm: {},
    setActiveTerm: () => {},
});
